import axios from "axios";

export const uploadFile = (
  formData: FormData,
  abortController?: AbortController
) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    signal: abortController?.signal,
  };
  return axios
    .post(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/uploads`,
      formData,
      config
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error;
    });
};

export const uploadFileIBitz = (formData: FormData) => {
  const requestHeader = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "multipart/form-data",
  };
  delete requestHeader["Content-Type"];
  const requestOptions: RequestInit = {
    method: "POST",
    headers: requestHeader,
    body: formData,
    redirect: "follow",
  };

  return fetch(`https://upload.i-bitz.co.th/upload`, requestOptions)
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
};

export const sendEmail = (emails: string[], stringHtml: string) => {
  return fetch(
    `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/send-emails`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        to: emails,
        subject: "MEA Design - Project Completed",
        body: stringHtml,
      }),
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      console.log("error", error);
      return error;
    });
};
